import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';
import NProgress from 'nprogress';

const isSafari =
  typeof navigator !== 'undefined' &&
  /safari/i.test(navigator.userAgent) &&
  !/chrome|chromium|crios|android|edgios|fxios/i.test(navigator.userAgent);

if (isSafari && typeof document !== 'undefined') {
  document.documentElement.classList.add('no-zoom');
}

if (environment.production && environment.env !== 'test' && environment.env !== 'sandbox'	) {
  enableProdMode();
}

// LogRocket ya NO se inicializa aquí. Lo decide SessionRecordingService según la
// configuración de SuperPay (`enable_logrocket` / `logrocket_enabled_for`): en modo
// 'all' arranca al cargar la config, y en modo 'selected' solo para los usuarios
// habilitados, cuya lista de correos vive en la config interna cifrada del gateway.
// Ver src/app/services/session-recording.service.ts

NProgress.configure({
  showSpinner: false, // Hide spinner
  speed: 300, // Increase speed
  minimum: 0.2 // Start from 20%
});

platformBrowserDynamic()
  .bootstrapModule(AppModule)
  .catch((err) => console.error(err));
